import { render } from "./app-logo.vue?vue&type=template&id=b2d06268"
import script from "./app-logo.vue?vue&type=script&lang=js"
export * from "./app-logo.vue?vue&type=script&lang=js"

import "./app-logo.vue?vue&type=style&index=0&id=b2d06268&lang=less"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__